(function() {
	/* eslint-disable no-var */
/* eslint-disable prefer-template */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable-next-line prefer-template */

var dIframeAnchor = document.createElement('div');
dIframeAnchor.style.cssText = "width: 90px;height: 290px;bottom: 0px;right: 0px;background: transparent;position: fixed;z-index: 99999999;border: none;overflow: auto;";
document.getElementById("webchat").appendChild(dIframeAnchor);

var nChekkitIFrameContainer = document.createElement('iframe');
nChekkitIFrameContainer.id = 'chekkit-frame';
nChekkitIFrameContainer.name = 'chekkit-frame';
nChekkitIFrameContainer.setAttribute('title', 'Customer support chat widget');
nChekkitIFrameContainer.setAttribute('role', 'complementary');
nChekkitIFrameContainer.setAttribute(
	'aria-label',
	'Chat with our support team'
);
nChekkitIFrameContainer.style.width = '290px';
nChekkitIFrameContainer.style.height = '220px';
nChekkitIFrameContainer.style.bottom = '0px';
nChekkitIFrameContainer.style.right = '0px';
nChekkitIFrameContainer.style.background = 'transparent';
nChekkitIFrameContainer.style.position = 'fixed';
nChekkitIFrameContainer.style.zIndex = 99999999;
nChekkitIFrameContainer.style.border = 'none';
nChekkitIFrameContainer.style.overflow = 'auto';

dIframeAnchor.appendChild(nChekkitIFrameContainer);

var sendMessageToWidget = function (msg) {
	nChekkitIFrameContainer.contentWindow.postMessage(msg, '*');
};

window.chekkitSettings.toggleChat = () =>
	sendMessageToWidget('toggle chat', '*');

// addEventListener support for IE8
function bindEvent(element, eventName, eventHandler) {
	if (element.addEventListener) {
		element.addEventListener(eventName, eventHandler, false);
	} else if (element.attachEvent) {
		element.attachEvent('on' + eventName, eventHandler);
	}
}

var parentOriginalBodyOverflowStyle = parent.document.body.style.overflow;
var parentOriginalBodyPositionStyle = parent.document.body.style.position;

bindEvent(window, 'message', function (e) {
	var widthOfTheParentScreen = screen.width;
	if (e.data === 'show chat') {
		nChekkitIFrameContainer.style.width =
			widthOfTheParentScreen > 500 ? '360px' : '100%';
		nChekkitIFrameContainer.style.height =
			widthOfTheParentScreen > 500 ? '650px' : '100%';
		nChekkitIFrameContainer.width =
			widthOfTheParentScreen > 500 ? '360px' : '100%';
		nChekkitIFrameContainer.height =
			widthOfTheParentScreen > 500 ? '650px' : '100%';

		if (widthOfTheParentScreen < 500) {
			parent.document.body.style.overflow = 'hidden';
			parent.document.body.style.position = 'fixed';
		}
	}

	// adjust iframe to be only large enough for the button
	if (e.data === 'hide chat') {
		nChekkitIFrameContainer.style.width = '90px';
		nChekkitIFrameContainer.style.height = '90px';
		nChekkitIFrameContainer.height = '90px';
		nChekkitIFrameContainer.width = '90px';

		if (widthOfTheParentScreen < 500) {
			parent.document.body.style.overflow =
				parentOriginalBodyOverflowStyle;
			parent.document.body.style.position =
				parentOriginalBodyPositionStyle;
		}
	}

	// adjust iframe to be larger for the helper window
	if (e.data === 'show greeting') {
		nChekkitIFrameContainer.style.width = '290px';
		nChekkitIFrameContainer.style.height = '220px';
		nChekkitIFrameContainer.height = '220px';
		nChekkitIFrameContainer.width = '290px';

		if (widthOfTheParentScreen < 500) {
			parent.document.body.style.overflow =
				parentOriginalBodyOverflowStyle;
			parent.document.body.style.position =
				parentOriginalBodyPositionStyle;
		}
	}

	if (e.data === 'get screen width') {
		sendMessageToWidget('width ' + widthOfTheParentScreen);
	}

	// Handle request for parent domain
	if (e.data === 'get_parent_domain') {
		try {
			// Extract domain from the current URL
			const url = new URL(window.location.href);
			const domain = url.hostname;
			sendMessageToWidget('parent_domain ' + domain);
		} catch (err) {
			sendMessageToWidget('parent_domain unknown');
		}
	}

	// Handle request for parent full URL
	if (e.data === 'get_parent_full_url') {
		try {
			// Send the full URL
			sendMessageToWidget('parent_full_url ' + window.location.href);
		} catch (err) {
			sendMessageToWidget('parent_full_url unknown');
		}
	}

	if (e.data === 'app_id') {
		if (parent.window.chekkitSettings) {
			sendMessageToWidget(
				'app_id ' + parent.window.chekkitSettings.app_id
			);
		}
	}

	if (
		e.data &&
		typeof e.data === 'string' &&
		e.data.indexOf('position') !== -1
	) {
		const isLeft = e.data.split(' ')[1] === 'left';
		if (isLeft) {
			nChekkitIFrameContainer.style.right = null;
			nChekkitIFrameContainer.style.left = '0px';
		}
	}

	// Google analytics and Google tag manager functions
	if (e.data === 'show chat') {
		if (parent.gtag && typeof parent.gtag === 'function') {
			parent.gtag('event', 'Textchat Opened', {
				event_category: 'Textchat',
				event_action: 'Textchat Opened',
				event_label: 'Textchat opened by user',
			});
		}

		if (parent.dataLayer && typeof parent.dataLayer === 'object') {
			parent.dataLayer.push({
				event: 'Textchat Opened',
				eventModel: {
					event_category: 'Textchat',
					event_action: 'Textchat Opened',
					event_label: 'Textchat opened by user',
				},
			});
		}
	}

	if (e.data === 'close chat') {
		if (parent.gtag && typeof parent.gtag === 'function') {
			parent.gtag('event', 'Textchat Closed', {
				event_category: 'Textchat',
				event_action: 'Textchat Closed',
				event_label: 'Textchat closed by user',
			});
		}

		if (parent.dataLayer && typeof parent.dataLayer === 'object') {
			parent.dataLayer.push({
				event: 'Textchat Closed',
				eventModel: {
					event_category: 'Textchat',
					event_action: 'Textchat Closed',
					event_label: 'Textchat closed by user',
				},
			});
		}
	}

	if (e.data === 'sent message') {
		if (parent.gtag && typeof parent.gtag === 'function') {
			parent.gtag('event', 'Textchat Message', {
				event_category: 'Textchat',
				event_action: 'Textchat Message',
				event_label: 'User sent new Textchat message',
			});
		}

		if (parent.dataLayer && typeof parent.dataLayer === 'object') {
			parent.dataLayer.push({
				event: 'Textchat Message',
				eventModel: {
					event_category: 'Textchat',
					event_action: 'Textchat Message',
					event_label: 'User sent new Textchat message',
				},
			});
		}
	}
});

// this is inside the iframe
// Create content for the iframe
var iframeContent = `<!doctype html>
    <head>
        <title>Customer Support Chat</title>
        <script async defer src='https://chatbot.chekkit.io/v1/widget.js'></script>
    </head>
    <body></body>
</html>`;

// Function to detect if we're on a Wix site
function isWixSite() {
	// Check for Wix-specific elements, meta tags, or global variables
	return (
		// Check for Wix meta tags
		!!document.querySelector('meta[name="generator"][content*="Wix"]') ||
		// Check for Wix-specific classes or elements
		!!document.querySelector('[class*="wix-"]') ||
		// Check for Wix global variables
		typeof window.wixPerformanceMeasurements !== 'undefined' ||
		typeof window.wixBiSession !== 'undefined' ||
		typeof window.wixEmbedsAPI !== 'undefined' ||
		// Check for Wix in the URL (for Wix subdomain sites)
		window.location.hostname.indexOf('.wixsite.com') > -1 ||
		// Check for Wix in the document HTML
		document.documentElement.innerHTML.indexOf('wix-') > -1
	);
}

// For Wix sites, always use the data URL approach
// For other sites, try srcdoc first if supported
if (isWixSite()) {
	// Always use data URL for Wix sites
	var dataUrl =
		'data:text/html;charset=utf-8,' + encodeURIComponent(iframeContent);
	nChekkitIFrameContainer.src = dataUrl;
} else if ('srcdoc' in nChekkitIFrameContainer) {
	// Use srcdoc for non-Wix sites that support it
	nChekkitIFrameContainer.srcdoc = iframeContent;
} else {
	// Fallback to data URL for browsers that don't support srcdoc
	var dataUrl =
		'data:text/html;charset=utf-8,' + encodeURIComponent(iframeContent);
	nChekkitIFrameContainer.src = dataUrl;
}
})();